import { createElementBlock as o, openBlock as r, createElementVNode as n } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function c(m, e) {
  return r(), o("svg", t, e[0] || (e[0] = [
    n("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m8.21 2.5 1.782 1.781m4.016 0L15.79 2.5M9.158 7.36v-.947a2.845 2.845 0 1 1 5.684 0v.947M12 19.553c-3.126 0-5.684-2.558-5.684-5.685v-2.842a3.79 3.79 0 0 1 3.79-3.79h3.789a3.79 3.79 0 0 1 3.79 3.79v2.842c0 3.127-2.559 5.685-5.685 5.685m0 0v-8.527M6.818 9.132c-1.829-.19-3.344-1.8-3.344-3.79m2.842 7.58h-3.79m.948 7.578c0-1.99 1.61-3.695 3.6-3.79M20.498 5.342c0 1.99-1.516 3.6-3.316 3.79m4.292 3.79h-3.79m-.758 3.788c1.99.095 3.6 1.8 3.6 3.79"
    }, null, -1)
  ]));
}
const s = { render: c };
export {
  s as default,
  c as render
};
